"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const field_logic_1 = require("../../field-type-registry/field-logic");
const fields_1 = require("../../utils/fields");
const google_sheet_1 = require("../../utils/google-sheet");
const intl_1 = require("../../locale/intl");
const vote_fieldtype_1 = require("../../safe-field-value/numder-fields/vote-field/vote.fieldtype");
const texts_1 = require("../../texts");
const validation_1 = require("../../validation/validation");
const comparisons_1 = require("../../comparisons/comparisons");
const filterComparisons = ["is_empty", "is_not_empty"];
class VoteFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.aggregates = {
            empty: {
                label: (0, intl_1.$t)(texts_1.aggregatesText.empty),
                aggregator: field_logic_1.countEmpty,
            },
            "non-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.non_empty),
                aggregator: field_logic_1.countFilled,
            },
            "percent-filled": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_filled),
                aggregator: field_logic_1.percentFilled,
            },
            "percent-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_empty),
                aggregator: field_logic_1.percentEmpty,
            },
        };
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_equal_to: comparisons_1.isEqualTo,
            is_not_equal_to: comparisons_1.isNotEqualTo,
            is_greater_than: comparisons_1.isGreaterThanAndNotEmpty,
            is_less_than: comparisons_1.isLessThanAndNotEmpty,
            is_equal_or_greater_than: comparisons_1.isEqualOrGreaterThanAndNotEmpty,
            is_equal_or_less_than: comparisons_1.isEqualOrLessThanAndNotEmpty,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
        };
        this.name = "votefield";
        this.label = (0, intl_1.$t)(texts_1.voteFieldText.vote);
        this.icon = "vote";
        this.iconColor = "#3A86FF";
        this.placeholder = (0, intl_1.$t)(texts_1.voteFieldText.enter_number_here);
        this.searchSynonyms = [(0, intl_1.$t)(texts_1.voteFieldText.poll)];
        this.groupByMode = "groupBy";
        this.lookupMode = "lookup";
        this.fieldValueGetter = new vote_fieldtype_1.VoteFieldValueGetter();
    }
    get validators() {
        return { required: validation_1.required };
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            saveKeys: types_1.navigationKeys,
            switchToInputControl: "OnCellSelect",
            editorWidth: "100%",
            editOnStartTyping: false,
            enableCopyEventInEditMode: true,
            spaceKeyOpensRecordModal: () => true,
            allowAddRecordToGroup: false,
            canBulkClean(field) {
                return true;
            },
        };
    }
    processFieldValue(record, slug, comparison, field) {
        const fieldValue = (0, fields_1.getValueFromRecordByField)(record, field);
        if (filterComparisons.includes(comparison)) {
            return (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.total_votes) || "";
        }
        return (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.total_votes.toString()) || "0";
    }
    sortKey(fieldValue) {
        return (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.total_votes) || Number.NEGATIVE_INFINITY;
    }
    valueToString(fieldValue) {
        var _a, _b;
        return (_b = (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.total_votes.toString()) !== null && _a !== void 0 ? _a : fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString()) !== null && _b !== void 0 ? _b : "0";
    }
    valueToGoogleSheet(fieldValue) {
        const value = (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.total_votes) || 0;
        return (0, google_sheet_1.makeRowDataValues)(value, "numberValue");
    }
    valueToExcelExport(fieldValue, field, userPreferences, _record) {
        return {
            t: "n",
            v: this.valueToExport(fieldValue, field, userPreferences, _record),
        };
    }
    isValueEmpty(fieldValue) {
        return (0, react_fast_compare_1.default)(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.total_votes, 0);
    }
    getEmptyValue() {
        return {
            total_votes: 0,
            votes: [],
        };
    }
    formatActivityRecordChangeValues(previousValue, currentValue) {
        const _currentValue = currentValue !== null && currentValue !== void 0 ? currentValue : this.getEmptyValue();
        const previousVotesCount = (previousValue === null || previousValue === void 0 ? void 0 : previousValue.total_votes) || 0;
        if (_currentValue.total_votes > previousVotesCount) {
            return { previousValue: undefined, currentValue: _currentValue };
        }
        return { previousValue: _currentValue, currentValue: undefined };
    }
    showActivityUpdate(value) {
        // When we added a vote we should display only current value and vice versa
        // if we deleted a vote we should display previous value.
        // see formatActivityRecordChangeValues method above.
        return value !== undefined;
    }
    isValueEqual(fieldValue1, fieldValue2) {
        return (0, react_fast_compare_1.default)(fieldValue1, fieldValue2);
    }
    canChangeValue(_field, fromValue, toValue) {
        return this.isValueEqual(fromValue, toValue);
    }
    getDuplicateFieldOptions() {
        return {
            includeContentChecked: false,
            includeContentDisabled: true,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 110,
            minWidth: 60,
        };
    }
    shouldCleanUpEmptyInLookupFilter(comparison) {
        return ["is_empty", "is_not_empty"].includes(comparison);
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.VoteFieldLogic = VoteFieldLogic;
